import { render } from "./Dashboard1.html?vue&type=template&id=38445bdc&scoped=true&ts=true"
import script from "./Dashboard1.ts?vue&type=script&lang=ts"
export * from "./Dashboard1.ts?vue&type=script&lang=ts"

import "./Dashboard1.scss?vue&type=style&index=0&id=38445bdc&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38445bdc"]])

export default __exports__